import { useState, useEffect } from 'react';
import { NAV_PAGES } from '../data';
import './Navbar.css';
import logo from "../assets/img/NavbarLogo1.png"

export default function Navbar({ page, setPage }) {
  const [solid, setSolid] = useState(false);
  const [mob, setMob] = useState(false);

  useEffect(() => {
    const fn = () => setSolid(window.scrollY > 60);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const go = (p) => {
    setPage(p);
    setMob(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <nav className={`nav${solid || page !== 'Home' ? ' solid' : ''}`}>
        <div className="nav-logo" onClick={() => go('Home')}>
          <div className="nav-logo-hex">
           <img className='navbar-logo' src={logo} alt="Logo" />
          </div>
          <p>FITNESS<span> KING</span></p>
        </div>

        <ul className="nav-links">
          {NAV_PAGES.map((p) => (
            <li key={p}>
              <a
                className={`${p === 'Contact' ? 'nav-join' : ''} ${page === p ? 'active' : ''}`}
                onClick={() => go(p)}
              >
                {p}
              </a>
            </li>
          ))}
        </ul>

        <button className="hamburger" onClick={() => setMob((o) => !o)} aria-label="Menu">
          <span style={{ transform: mob ? 'rotate(45deg) translate(5px,5px)' : '' }} />
          <span style={{ opacity: mob ? 0 : 1 }} />
          <span style={{ transform: mob ? 'rotate(-45deg) translate(5px,-5px)' : '' }} />
        </button>
      </nav>

      <div className={`mob-menu${mob ? ' open' : ''}`}>
        <button className="mob-close" onClick={() => setMob(false)}>✕</button>
        {NAV_PAGES.map((p) => (
          <a key={p} onClick={() => go(p)}>{p}</a>
        ))}
      </div>
    </>
  );
}
